export const marketingRouteNames = {
  default: 'marketing-v2',
  socialPlanner: {
    default: 'social-planner-dashboard-v2',
    list: 'social-planner-list-v2',
    post: 'social-planner-post-v2',
    postEdit: 'social-planner-post-edit-v2',
    importCSV: 'social-planner-post-import-v2',
    planner: 'social-planner-planner',
    plannerSetting: 'social-planner-settings-v2',
    categoryQueue: 'social-planner-category-queue',
    csvCreate: 'social-planner-csv-create',
    csvEdit: 'social-planner-csv-edit',
    content: 'social-planner-content',
    statistics: 'social-planner-statistics',
    comments: 'social-planner-comments',
    socialListening: 'social-planner-social-listening',
  },
  emails: {
    default: 'emails_home-v2',
    templates: 'emails_home-v2-templates',
    campaigns: 'emails_home-v2-campaigns',
    statistics: 'emails_home-v2-statistics',
    settings: 'emails_home-v2-settings',
    campaignStats: 'emails_home-v2-campaign-statistics',
  },
  brandBoard:{
    default:'brand-boards',
    builder:'brand-boards-builder',
    voiceBuilder:'brand-voice-builder',
  },
  prospecting: {
    default: 'prospecting',
  },
  templates: 'templates-v2',
  triggerLinks: {
    default: 'triggers-links-v2',
    link: 'triggers-links-link-v2',
    analyze: 'triggers-links-analyze-v2',
  },
  adManager: {
    default: 'ad-manager',
    home: 'ad-manager-home',
    campaignBuilder: 'campaign-builder',
    settings: 'ad-manager-settings',
    campaignStatistics: 'campaign-statistics',
  },
  affiliateManager: {
    default: 'affiliate-manager-v2',
    campaigns: {
      default: 'affiliate-manager-campaign-page-v2',
      create: 'campaign-create-page-v2',
      edit: 'campaign-edit-page-v2',
    },
    dashboard: 'affiliate-manager-dashboard-page-v2',
    affiliates: {
      default: 'affiliate-manager-affiliates-v2',
      details: 'affiliate-manager-affiliates-details-v2',
    },
    payouts: 'affiliate-manager-payouts-v2',
    media: {
      default: 'affiliate-manager-media-v2',
      folder: 'affiliate-manager-media-folder-v2',
    },
    settings: 'affiliate-manager-settings-v2',
  },
  countdownTimer: {
    default : 'countdown-timer-list-v2'
  },
  contentAI: {
    default: 'content-ai-v2'
  },
}
